// eventBus.js
// 作为一个中央事件总线
// https://cn.vuejs.org/v2/guide/components.html#非父子组件通信
import Vue from 'vue'
export default new Vue()
